module Meevo.Plugins.Departments {
    "use strict";

    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    /**
    * Main Section of departments 
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Department> {
        public employeeCriteria: any;
        public serviceCategoryCriteria: any;
        public productCategoryCriteria: any;

        get securityAccessEnum(): any {
            return SecurityAccessEnum;
        }

        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;

                this.getDepartment();
                this.createCopy();
            });
        }

        sectionModelRetrieved(): void {
            this.getDepartment();
        }

        getDepartment(): void {
            if (!this.model) { return; }

            let businessTypeId = null;
            if (this.model.businessTypeDetail) {
                businessTypeId = this.model.businessTypeDetail.id == '00000000-0000-0000-0000-000000000001' ? null : this.model.businessTypeDetail.id;
            }

            this.employeeCriteria = {
                criteria: {
                    showEmployeesOnly: true
                },
                advancedSearch: {
                    asLocationId: this.model.locationId
                }
            };

            this.serviceCategoryCriteria = {
                criteria: {
                    notAssignedToDepartment: true,
                    coSearchType: 0,
                    coBusinessTypeId: businessTypeId,
                    departmentId: this.model ? this.model.id : null
                },
                advancedSearch: {
                    asLocationId: this.model.homeLocationId
                }
            };

            this.productCategoryCriteria = {
                criteria: {
                    coSearchType: 0,
                    coBusinessTypeId: businessTypeId,
                    departmentId: this.model ? this.model.id : null,
                    notAssignedToDepartment: true
                },
                advancedSearch: {
                    asLocationId: this.model.homeLocationId
                }
            };
        }
    }

}
